// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__mYYpe","content":"styles_content__2yv2a","checkbox":"styles_checkbox__2mm9I","checkboxLabel":"styles_checkboxLabel__153vK"};